// Import model
import { DictionaryField } from '../models/DictionaryField';

// Import base class serializer
import { FieldSerializer } from './FieldSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DictionaryField - handles JSON serialization and deserialization with type validation
 */
export class DictionaryFieldSerializer {
  /**
   * Deserializes a JSON string into a DictionaryField instance
   */
  static deserialize(json: string): DictionaryField {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DictionaryField instance
   */
  static fromObject(obj: any): DictionaryField {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DictionaryField');
    }


    const instance: DictionaryField = {
      t: obj['_t'] as string,
      description: obj['Description'] as string | undefined,
      apiName: obj['ApiName'] as string | undefined,
      defaultValue: obj['DefaultValue'] as any | undefined,
      isRequired: obj['IsRequired'] as boolean | undefined,
      options: obj['Options'] ? FieldOptionsSerializer.fromObject(obj['Options']) : undefined as any,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      dba8F74B: obj['_dba8f74b'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DictionaryField instances
   */
  static deserializeArray(json: string): DictionaryField[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DictionaryField instance to a JSON string
   */
  static serialize(instance: DictionaryField): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DictionaryField instance to a plain object
   */
  static toObject(instance: DictionaryField): any {
    return {
      '_t': instance.t,
      'Description': instance.description,
      'ApiName': instance.apiName,
      'DefaultValue': instance.defaultValue,
      'IsRequired': instance.isRequired,
      'Options': instance.options ? FieldOptionsSerializer.toObject(instance.options) : undefined,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      '_dba8f74b': instance.dba8F74B,
    };
  }

  /**
   * Serializes an array of DictionaryField instances to a JSON string
   */
  static serializeArray(instances: DictionaryField[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
